import { Dispatch } from "redux";
import {
    AttendanceCollectionInfo,
    CollectionDetail,
    CollectionPhotoList,
    UnloadCollectionInfo,
    UnloadImageList,
    
} from "./state";
import {
    ChangeAttendaceDateTimeAction,
    ChangeCollectionDetailAction,
    ChangeCollectionWeightAction,
    ChangeCollectionPhotoListAction,
    ChangeContainerAction,
    ChangeRecyclabeAction,
    ChangeUnloadCollectionDepotAction,
    ChangeUnloadCollectionMetalAction,
    ChangeUnloadCollectionPaperAction,
    ChangeUnloadCollectionPlasticAction,
    ChangeUnloadCollectionTotalWeightAction,
    CollectionAction,
    InitSelectedUnloadCollectionAction,
    changeBinInfoAction,
    handleCollectionDateAction,
    initCollectionAttendanceAction,
    initCollectionDetailAction,
    initSelectedEditattendanceAction,
    initSelectedEditionCollectionDetailAction,
    initUnloadDataAction,
    initUnloadImageAction,
    ChangeSignatureImageAction,
} from "./action";
import { BinInfo, ContainerList, RecylcableList } from "../staticInfo/state";
import { SingleValue } from "react-select";

export function initCollectionDetailThunk(
    collecitonDetail: CollectionDetail[],
    signature_image: string,
    signature_image_thumb: string,
    collectionPhotoList: CollectionPhotoList[]
) {
    return (dispatch: Dispatch<CollectionAction>) => {
        dispatch(
            initCollectionDetailAction(
                collecitonDetail,
                signature_image,
                signature_image_thumb,
                collectionPhotoList
            )
        );
    };
}

export function initCollectionAttendanceData(
    attendanceCollectionInfo: AttendanceCollectionInfo[]
) {
    return (dispatch: Dispatch<CollectionAction>) => {
        dispatch(initCollectionAttendanceAction(attendanceCollectionInfo));
    };
}

export function initUnloadDataThunk(
    unloadCollectionInfo: UnloadCollectionInfo[]
) {
    return (dispatch: Dispatch<CollectionAction>) => {
        dispatch(initUnloadDataAction(unloadCollectionInfo));
    };
}

export function initImageListThunk(unloadImageList: UnloadImageList[]) {
    return (dispatch: Dispatch<CollectionAction>) => {
        dispatch(initUnloadImageAction(unloadImageList));
    };
}

export function initSelectedEditattendanceThunk(
    attendanceCollectionInfo: AttendanceCollectionInfo
) {
    return (dispatch: Dispatch<CollectionAction>) => {
        dispatch(initSelectedEditattendanceAction(attendanceCollectionInfo));
    };
}

export function changeBinInfoThunk(binInfo: SingleValue<BinInfo>) {
    return (dispatch: Dispatch<CollectionAction>) => {
        dispatch(changeBinInfoAction(binInfo));
    };
}

export function ChangeAttendaceDateTimeThunk(date: Date | moment.Moment) {
    return (dispatch: Dispatch<CollectionAction>) => {
        dispatch(ChangeAttendaceDateTimeAction(date));
    };
}

export function handleCollectionDatethunk(date: Date) {
    return (dispatch: Dispatch<CollectionAction>) => {
        dispatch(handleCollectionDateAction(date));
    };
}

export function initSelectedEditionCollectionDetailThunk(
    data: CollectionDetail
) {
    return (dispatch: Dispatch<CollectionAction>) => {
        dispatch(initSelectedEditionCollectionDetailAction(data));
    };
}

export function ChangeRecyclabeThunk(
    recylcableList: RecylcableList[],
    recyclable_id: string
) {
    const targetReyclableInfo = recylcableList.find(
        (recycable) => recycable.recyclable_id === parseInt(recyclable_id)
    );

    return (dispatch: Dispatch<CollectionAction>) => {
        dispatch(ChangeRecyclabeAction(targetReyclableInfo!));
    };
}

export function ChangeContainerThunk(
    containerList: ContainerList[],
    container_id: string,
    collection_weight: string
) {
    const targetReyclableInfo = containerList.find(
        (container) => container.container_id === parseInt(container_id)
    );

    return (dispatch: Dispatch<CollectionAction>) => {
        dispatch(
            ChangeContainerAction(targetReyclableInfo!, collection_weight)
        );
    };
}

export function ChangeCollectionWeightThunk(
    containerList: ContainerList[],
    container_id: string,
    collection_weight:string
    ){
        const targetReyclableInfo = containerList.find(
            (container) => container.container_id === parseInt(container_id)
        );
      
    return (dispatch: Dispatch<CollectionAction>) => {
        dispatch(ChangeCollectionWeightAction(collection_weight,targetReyclableInfo!));
    };

}

export function ChangeCollectionDetailThunk(selectedEditCollectionDetail: CollectionDetail|any, collecitonDetail: CollectionDetail[]){

    const newCollectionDetail = collecitonDetail.map((collection)=>{
        if (collection.collection_response_id ===selectedEditCollectionDetail.collection_response_id){
            return selectedEditCollectionDetail
        }else{
            return collection
        }
    })

    return (dispatch: Dispatch<CollectionAction>) => {
        dispatch(ChangeCollectionDetailAction(newCollectionDetail));
    };

}

export function InitSelectedUnloadCollectionThunk(unloadCollectionInfo:UnloadCollectionInfo){
    return (dispatch: Dispatch<CollectionAction>) => {
        dispatch(InitSelectedUnloadCollectionAction(unloadCollectionInfo));
    };
}



export function ChangeUnloadCollectionDepotThunk(depot_id:string){
    return (dispatch: Dispatch<CollectionAction>) => {
        dispatch(ChangeUnloadCollectionDepotAction(depot_id));
    };
}


export function ChangeUnloadCollectionMetalThunk(metal_weight:string,paper_weight:number,plastic_weight:number){
    let total_weight = (parseFloat(metal_weight)+paper_weight+plastic_weight).toFixed(1)


    return (dispatch: Dispatch<CollectionAction>) => {
        dispatch(ChangeUnloadCollectionMetalAction(metal_weight,total_weight));
    };
}


export function ChangeUnloadCollectionPaperThunk(paper_weight:string,metal_weight:number,plastic_weight:number){
    let total_weight = (parseFloat(paper_weight)+metal_weight+plastic_weight).toFixed(1)
    return (dispatch: Dispatch<CollectionAction>) => {
        dispatch(ChangeUnloadCollectionPaperAction(paper_weight,total_weight));
    };
}

export function ChangeUnloadCollectionPlasticThunk(plastic_weight:string,paper_weight:number,metal_weight:number){
    let total_weight = (parseFloat(plastic_weight)+metal_weight+paper_weight).toFixed(1)
    return (dispatch: Dispatch<CollectionAction>) => {
        dispatch(ChangeUnloadCollectionPlasticAction(plastic_weight,total_weight));
    };
}

export function ChangeUnloadCollectionTotalWeightThunk(total_weight:string){

    return (dispatch: Dispatch<CollectionAction>) => {
        dispatch(ChangeUnloadCollectionTotalWeightAction(parseFloat(total_weight).toFixed(1)));
    };
}

export function ChangeUnloadDataListThunk( unloadCollectionInfo: UnloadCollectionInfo[] ,selectedUnloadCollectionInfo:UnloadCollectionInfo ){
    const newUnloadCollectionList = unloadCollectionInfo.map((unload)=>{
        if (unload.unload_detail_id ===selectedUnloadCollectionInfo.unload_detail_id){
            return selectedUnloadCollectionInfo
        }else{
            return unload
        }
    })

    return (dispatch: Dispatch<CollectionAction>) => {
        dispatch(initUnloadDataAction(newUnloadCollectionList));
    };
}


export function ChangeCollectionPhotoListThunk(
    collectionPhotoList: CollectionPhotoList[]
) {
    return (dispatch: Dispatch<CollectionAction>) => {
        dispatch(ChangeCollectionPhotoListAction(collectionPhotoList));
    };
}

export function ChangeSignatureImageThunk(signature_imageBlob:string){

    return (dispatch: Dispatch<CollectionAction>) => {
        dispatch(ChangeSignatureImageAction(signature_imageBlob));
    };
}
